import { Component, OnInit } from '@angular/core';
import { OfbizList, OfbizForm } from '@urbannex/ofbiz-forms';
import { ActionState, BaseComponentConfig, ComponentConfig, ConfigOptions, UpdateComponentStoreService, ViewContainersService, getColumnFieldTitles, getFields } from '@urbannex/view-containers';
import { IMG_FORMS } from '../../forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';

@Component({
  selector: 'ubs-upload-additional-images',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./upload-additional-images.component.scss']
})
export class UploadAdditionalImagesComponent extends BaseComponentConfig implements OnInit {
  productId:string;
  uploadImgOptions:ConfigOptions = {
    name: 'Upload Additional Images',
    title: 'Upload Additional Images',
    defaultAction:ActionState.RELATE,
    listForm: undefined,
    findForm: undefined,
    addForm: undefined,
    actions: [],
    settings: [],
    breadCrumbData:{
      displayPrefix:"Gallery For ",
      label:"",
      level:1,
      selectedValue:{
      "event":"relate",
      "type":"ProductImages",
      "data":{
          formData:{
          formName:"ProductImages",
          formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
          listType:"grid"
          },
          "endPoint":""
      }
      },
      addFormText:"Upload Product Image",
      editFormText:"Update Product Image"
  },
    relations:[
      {
        title:"Upload Additional Images",
        addContainerTitle:"Add Images", 
        listContainerTitle:"Uploaded Images for "+this.getProductId(), 
        keyMap:{fieldName:"productId"}, 
        addFormName:"AddMultipleImages", 
        listFormName:"ListImageUpload",
        addForm:new OfbizForm({
          formName:"AddMultipleImages",
          local:true,
          formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
          fields:getFields("AddMultipleImages",IMG_FORMS),
        }),
        listForm:new OfbizList({
          listFormName:"ListImageUpload",
          listFormLocation:"component://kwikstore/widget/ImageManagementForms.xml",
          columnFields:getFields("ListImageUpload",IMG_FORMS),
          columnFieldTitles:getColumnFieldTitles("ListImageUpload",IMG_FORMS),
          fieldFormFields:getFields("ListImageUpload",IMG_FORMS),
          emptyListMessage:"No images found",
          listType:"list",
          remoteFormData:{
            formData:{
              formName:"ListImageUpload",
              formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
              viewIndex:0,
              listType:"list",
            },
            appContext:"catalog",
            parameters:{"productId":""}
    
          }
        })         
      }
    ]
  }
  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    private http:HttpClient,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService);
    this.route.paramMap.subscribe((params) => {
      this.routerParams = params;
      this.productId = params.get("productId");
      //console.log(params.get("productId"));

      this.uploadImgOptions.relations[0].listForm.remoteFormData.parameters["productId"] = params.get("productId");
      console.log(this.uploadImgOptions.relations[0].listForm);
      this.componentConfig = new ComponentConfig(this.uploadImgOptions);
    })
    
   }
  ngOnInit(): void {
    this.baseUrl = this.getBaseUrl();
  }

  getProductId(){
    return this.productId;
  }
}
